import React from "react";
import { Table, Accordion, Card, Container, Col, Row, Modal } from "react-bootstrap";
import PersonView from "./PersonView";
import ModalPersonRenderer from "./renderers/ModalPersonRenderer";
import StudentController from "../api/StudentController";
import Loader from "react-loader";

interface PreviousProgramsViewState
{
    modalData: Person;
    showModal: boolean;
    programsData: Program[];
    isLoading: boolean;
    open: boolean;
}

export default class PreviousProgramsView extends React.Component<any, PreviousProgramsViewState>
{
    studentController: StudentController;

    constructor(props: any)
    {
        super(props);
        this.studentController = new StudentController();
        this.state = {
            modalData: null,
            showModal: false,
            advisorsData: null,
            isLoading: true,
            open: false
        };
    }

    async getHistoricProgramsData()
    {
        let data = await this.studentController.getHistoricPrograms();

        if (!data)
        {
            data = {"programs": []}
        }

        this.setState({
            isLoading: false,
            programsData: data.programs,
            open: !this.state.open
        });
    }

    render(): React.ReactNode
    {
        const handleClose = () => this.setState({ showModal: false });
        const handleShow = (itm: any): void =>
        {
            this.setState({ showModal: true, modalData: itm });
        };

        return <React.Fragment>
            <Accordion>
                <Card>
                    <Accordion.Toggle aria-expanded={this.state.open} onClick={() => this.getHistoricProgramsData()} href={"javascript:void(0)"} as={"a"} variant="link" eventKey="0">
                        <Card.Header>
                            <Row>
                                <Col xs={10}>
                                    <b>HISTORICAL</b>
                                </Col>
                                <Col xs={1} className="text-right chevron">
                                    <i className={this.state.open ? " far fa-chevron-up" : "far fa-chevron-down"}></i>
                                </Col>
                            </Row>
                        </Card.Header>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="0">
                        <Card.Body>
                            {
                                this.state.isLoading
                                    ?
                                    <Container style={{ height: "100px", padding: "50px" }}>
                                        <Loader className={"spinner"} position={"relative"} scale={0.5} radius={15} corners={1} color={"#000"} opacity={0.25} rotate={0} direction={1} speed={1} trail={60} />
                                    </Container>
                                    :
                                    <Table responsive className="list">
                                        <thead>
                                            <tr style={{ color: "grey" }}>
                                                <th>TYPE</th>
                                                <th>TERM</th>
                                                <th>TITLE</th>
                                                <th>SUPERVISOR</th>
                                                <th>NOTES</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                (this.state.programsData && this.state.programsData.length > 0)
                                                    ?
                                                    this.state.programsData.map((program: Program, i: number) => 
                                                    {
                                                        return <tr key={i}>
                                                            <td className="td-normal">{program.type ? program.type : " - "}</td>
                                                            <td className="td-normal">{program.termCode ? program.termCode : " - "}</td>
                                                            <td>{program.title ? program.title : " - "}</td>
                                                            <td className="td-normal"><a style={{ color: "#1C4B87" }} onClick={(e): void => handleShow(program.supervisor)}><PersonView data={program.supervisor} /></a></td>
                                                            <td className="td-normal">
                                                                {
                                                                    program.notes
                                                                        ?
                                                                        (program.notes.includes("*")) ? "Student or Faculty has not yet submitted an evaluation" : program.notes
                                                                        :
                                                                        " - "
                                                                }
                                                            </td>
                                                        </tr>;
                                                    })
                                                    :
                                                    <tr className={"text-center"}>
                                                        <td colSpan={5}>
                                                            <p className="error-text">No Programs data available</p>
                                                        </td>
                                                    </tr>
                                            }
                                        </tbody>
                                    </Table>
                            }
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
            </Accordion>
            <Modal size={"sm"} centered show={this.state.showModal} onHide={handleClose}>
                <Modal.Body>
                    <ModalPersonRenderer data={this.state.modalData} />
                </Modal.Body>
            </Modal>
        </React.Fragment>;
    }
}